import site from "../../content/data/site.json"

// Static snapshot of the WordPress GLOBAL_FOOTER menu (previously a WPGraphQL static query)
export default function useQueryGlobalFooter() {
  return { wpMenu: site.footerMenu }
}
